import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import submittedgradesapi from '../api/submittedgrades';
import loginapi from '../api/login';
import SubmittedFormCard from '../components/SubmittedFormFillupCard';

import { APISERVERURL } from '../APIServerURL';
function SubmittedFormFillupReport({accessToken,setAccessToken,setRefreshFailed ,sessions=[] }) {
  const navigate = useNavigate();
  const [rollno,setRollno]=useState('');
  // const session='2025-DECEMBER';
    const [session,setSession]=useState("");

const [submittedFormFillups,setSubmittedFormFillups]=useState([]);


  const handleGoBack = () => {
    navigate(`/formfillupDetails`); 
  };


   const sessionChanged = async (e) => {
    const tsession = e.target.value;
    setSession(tsession);
  
  };

const handleRollnoChange = (e) => {
    setRollno(e.target.value);
  };

    
    async function handleSearch(e)
        {
          e.preventDefault();
          try{
            const response= await submittedgradesapi.post('/getFormFillupSemestersOfAStudent',{ rollno,session},{headers:{'Authorization':`Bearer ${accessToken}`}});    
             //alert(JSON.stringify(response.data));
             setSubmittedFormFillups(response.data.FormFillups);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await submittedgradesapi.post('/getFormFillupSemestersOfAStudent',{ rollno,session},{headers:{'Authorization':`Bearer ${nat}`}});    
                             setSubmittedFormFillups(response.data.FormFillups);

               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
        }
  

  async function handleAllowResubmit(semester,session,rollno)
        {
          
          try{
            const response= await submittedgradesapi.post('/allowResubmitFormFillupSemester',{ semester,session,rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});    
             //alert(JSON.stringify(response.data));
             setSubmittedFormFillups(response.data.FormFillups);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await submittedgradesapi.post('/allowResubmitFormFillupSemester',{ semester,session,rollno},{headers:{'Authorization':`Bearer ${nat}`}});    
                             setSubmittedFormFillups(response.data.FormFillups);

               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
        }
  


  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> ALLOW RESUBMISSION</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
        
        
         <div className="flex flex-col items-center text-center mb-4">
            <p className="text-center">Select Exam session</p>
            <select
        value={session}
        onChange={(e) => sessionChanged(e)}
        className="p-2 rounded border w-full"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
          </div>

        <div className="w-full flex items-center justify-center mt-4 ">
                <div
                  className="text-center w-full max-w-[600px]  grid grid-cols-[1fr_3fr_1fr] gap-2 p-1 text-sm align-items-end "
                >
                <label className="px-2 py-2">ROLLNO:</label>

                <input
                                type="text" 
                                name="txtRollno"
                                value={rollno}
                                onChange={handleRollnoChange}
                              className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
                              />
              <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95"
              onClick={handleSearch}>
                SEARCH
              </button>

                </div>
        </div>

         {submittedFormFillups.length > 0 ? (
  <div className="w-full flex flex-col justify-center items-center ">
    {submittedFormFillups.map((item, index) => (
     <SubmittedFormCard
    key={index}
    item={item}
    handleAllowResubmit={handleAllowResubmit}
    />
    ))}
  </div>
) : (
  <p className="text-center text-gray-500 mt-4">No submitted form fillups found.</p>
)}


      </div>
      </div>
    </main>
  );
}

export default SubmittedFormFillupReport;
